__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/COACH_Denim-World_01-03-24/";